<template>
	<div class="navWrap">
		<div class="wrap">
			<div class="logo">
				<img :src="logoimg" class="header-logos" alt=""/>
			</div>
			<div class="navWrap_center">
				<div class="dropdown-banner">
				<div class="dropdown">

					<button class="dropbtn" @click="homeRouter">首页</button>
					<!--<div class="dropdown-content">-->
						<!--<router-link to="/keji">业务涉及范围</router-link>-->
						<!--<router-link to="/zhijiao">核心技术体系</router-link>-->
						<!--<router-link to="/youjiao">合作伙伴</router-link>-->
					<!--</div>-->
				</div>
				<div class="dropdown">
					<button class="dropbtn" @click="productRouter">产品<span class="dropbtnpic"></span></button>
					<div class="dropdown-content">
						<router-link to="/intdata">运筹数据平台</router-link>
                        <router-link to="/dedvic">决胜数据管理平台</router-link>
                        <router-link to="/visual">智能可视化平台</router-link>
                        <router-link to="/infoc">信息采集平台</router-link>
                        <router-link to="/datagov">数据治理平台</router-link>
                        <router-link to="/dataeng">数据引擎</router-link>
						<!--<router-link to="/knobase">知识库平台</router-link>-->
						<!--<router-link to="/expbase">专家系统</router-link>-->
						<!--<router-link to="/decbase">智慧决策系统</router-link>-->
						<!--<router-link to="/pubbase">舆情管理系统</router-link>-->
					</div>
				</div>
				<div class="dropdown">
					<button class="dropbtn" @click="solution">解决方案<span class="dropbtnpic"></span></button>
					<div class="dropdown-content">
						<router-link to="/govSolution">政务</router-link>
						<router-link to="/finSolution">金融</router-link>
						<router-link to="/eduSolution">教育</router-link>
						<router-link to="/medSolution">医药医疗</router-link>
						<router-link to="/makeSolution">制造业</router-link>
						<router-link to="/milSolution">国防军工</router-link>
						<router-link to="/netSolution">互联网+</router-link>
					</div>
				</div>
				<div class="dropdown">
					<button class="dropbtn" @click="serviceRouter">服务支持</button>
				</div>
				<div class="dropdown">
					<button class="dropbtn" @click="aboutUs">关于我们<span class="dropbtnpic"></span></button>
					<div class="dropdown-content">
						<router-link to="/aboutUs">企业概况</router-link>
						<!--<router-link to="/zhijiao">发展历程</router-link>-->
						<!--<router-link to="/youjiao">认证与资质证明</router-link>-->
						<!--<router-link to="/dianshang">客户关系</router-link>-->
						<router-link to="/aboutTeam">团队介绍</router-link>
						<router-link to="/news">新闻资讯</router-link>
					</div>
				</div>
			</div>

				<!--<ul>-->
					<!--<li-->
						<!--v-for="(item, index) in navList"-->
						<!--:key="index"-->
						<!--@click="funyuming(item.url)"-->
					<!--&gt;-->
						<!--{{ item.title }}-->
					<!--</li>-->
				<!--</ul>-->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Nav",
	data() {
		return {
			// navList: [
			// 	{ title: "首页", url: "/" },
			// 	{ title: "企业概括", url: "/jituangaikuo" },
			// 	{ title: "企业产业", url: "/keji" },
			// 	{ title: "企业新闻", url: "/xinwen" },
			// 	{ title: "招聘详情", url: "/zhaopinxiangqing0_0" },
			// 	{ title: "联系我们", url: "/lianxi" },
			// 	{ title: "招聘信息", url: "/zhaopinxinxi0" },
			// ],
			logoimg: require("../assets/blacklogo.png"),
		};
	},
	methods: {
		homeRouter() {
			this.$router.push("/");
		},
		funyuming(msg) {
			this.$router.push(msg);
		},
		// newsArticle(index) {
		// 	this.$router.push("/newsxiangqing" + index);
		// },
		serviceRouter() {
			this.$router.push("/service");
		},
		productRouter() {
			this.$router.push("/intdata");
		},
		solution() {
			this.$router.push("/govSolution");
		},
		aboutUs() {
			this.$router.push("/aboutUs");
		},
	},
};
</script>
<style scoped>
	.navWrap {
		width: 1920px;
		position: absolute;
		top: 0;
		left: 0;
		/*  */
		/*padding-top: 40px;*/
		position: fixed;
		z-index: 9999;
	}
	@media screen and (max-device-width: 1900px) {
		.navWrap {
			height: auto;
			width: 1680px;
		}
	}
	@media screen and (max-device-width: 1500px) {
		.navWrap {
			height: auto;
			width: 1440px;
		}
	}
	@media screen and (max-device-width: 1400px) {
		.navWrap {
			height: auto;
			width: 1366px;
		}
	}
	@media screen and (max-device-width: 1300px) {
		.navWrap {
			height: auto;
			width: 1280px;
		}
	}
	@media screen and (min-device-width: 2000px) {
		.navWrap {
			height: auto;
			width: 2560px;
		}
	}
	/*.header-logos{*/
		/*!*float: left;*!*/
		/*padding-left: 100px;*/
		/*width: 100px;*/
		/*height: auto;*/
		/*justify-content:space-between;*/
		/*!*display:flex;*!*/
		/*!*align-items: center;*!*/
	/*}*/

	.dropbtnpic {
		content: ' '; /*必须设置content属性*/
		width: 0;
		height: 0;
		border-left: 6px solid transparent; /*左边*/
		border-right: 6px solid transparent; /*右边*/
		border-top: 6px solid #000; /*上边，箭头颜色为黑色*/
		position: absolute;
		/*right: 12px; !*调整箭头位置*!*/
		top: 50%; /*让箭头居中*/
		transform: translateY(-50%); /*向上位移50%*/
	}
	/*.header-logos{*/
		/*float: left;*/
		/*width: 200px;*/
		/*height: auto;*/
		/*!*display:flex;*!*/
		/*!*align-items: center;*!*/
	/*}*/
	/*.header-important{*/
		/*!*font-family: AlibabaPuHuiTi-3-55-Regular;*!*/
		/*margin: 10px 0 0 28px;*/
		/*float: left;*/
		/*align-self: center;*/
		/*!*margin-top: 70px;*!*/
		/*!*margin-left: 80px;*!*/
	/*}*/
	.navWrap_center {
		height: 80px;
		margin: 0 auto;
		background: #fff;
		/*border-radius: 51px;*/
		/*  */
		display: flex;
		justify-content: space-between;
	}
.wrap {
	height: 80px;
	margin: 0 auto;
	background: #fff;
	/*border-radius: 51px;*/
	display: flex;
	justify-content: space-between;
	/*position: relative;*/
	width: 100%;
	/*height: 80px;*/
	/*background-color: rgba(255, 255, 255, 1);*/
	/*box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);*/
}

.wrap > .logo > img {
	margin: 28px 28px 28px 28px;
	float: left;
	/*position: absolute;*/
	/*left: 360px;*/
	/*top: 23px;*/
	width: 150px;
	height: auto;
}
	/*@media screen and (min-device-width: 1400px) {*/
		/*.wrap > .logo > img {*/
			/*height: auto;*/
			/*width: 150px;*/
		/*}*/
	/*}*/

.nav {
	width: 556px;
	position: absolute;
	left: 1000px;
	top: -9px;
}

.nav ul {
	height: 100%;
}

.nav ul li {
	height: 46px;
	float: left;
	display: flex;
	list-style-type: none;
	color: rgba(68, 68, 68, 1);
	font-size: 16px;
	margin-right: 20px;
	line-height: 50%;
	cursor: pointer;
}

.nav ul li:hover {
	color: rgba(35, 51, 127, 1);
	border-bottom: 2px solid rgba(35, 51, 127, 1);
}
.dropbtn {
	background-color: #fff;
	color: rgba(68, 68, 68, 1);
	padding: 18px;
	font-size: 18px;
	border: none;
	cursor: pointer;
	font-family: AlibabaPuHuiTi-3-55-Regular;

}

.dropdown {
	top: 10px;
	left: 120px;
	position: relative;
	display: inline-block;
}

.dropdown-content {
	font-family: AlibabaPuHuiTi-3-55-Regular;
	z-index: 999;
	text-align: center;
	display: none;
	position: absolute;
	background-color: #f9f9f9;
	min-width: 160px;
	min-height: 120px;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}

.dropdown-content a {
	color: black;
	padding: 12px 16px;
	text-decoration: none;
	display: block;
}

.dropdown-content a:hover {
	background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
	display: block;
}
</style>
